export default __webpack_public_path__ + "static/media/axe_throwing_xmas.c01f5bcb.png";